<template>
    <el-dialog :class="[prefix]" title="发货状态更新" :modal-append-to-body="false" :visible.sync="visible" width="600px" center @closed="closed">
        <el-form :class="`${prefix}-user-info`">
            <el-form-item label="用户昵称">{{ info.username }}</el-form-item>
            <el-form-item label="奖品名称">{{ info.prizeName }}</el-form-item>
            <el-form-item label="抽奖活动来源">{{ info.activityName }}</el-form-item>
            <el-form-item label="中奖时间">{{ info.winningTime }}</el-form-item>
        </el-form>
        <el-form :class="`${prefix}-logistics`">
            <el-form-item label="物流公司">
                <el-input v-model="form.expressCompany" placeholder="如顺丰、圆通..."></el-input>
            </el-form-item>
            <el-form-item label="物流单号">
                <el-input v-model="form.expressOrderno" placeholder="请输入奖品寄送物流单号"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <el-button @click="visible = false">取 消</el-button>
            <el-button type="primary" @click="setShipping" :loading="loading">设为“已发货”</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { verifyField } from '@/common/utils'

const prefix = 'w-update-shipment-status-dialog'

export default {
    props: {
        value: Boolean,
        // 兑换记录ID 
        id: {
            type: [Number, String]
        }
    },
    data() {
        return {
            prefix,
            visible: false,
            form: {
                expressCompany: '',
                expressOrderno: ''
            },
            info: {},
            loading: false,
            verifyRules: {
                expressCompany: [{required: true, message: '请输入物流公司'}],
                expressOrderno: [{required: true, message: '请输入奖品寄送物流单号'}]
            }
        }
    },
    methods: {
        async activityWinningDetail() {
            this.info = await this.api.activityWinningDetail({
                access_token: localStorage.getItem("access_token"),
                id: this.id  
            })
        },
        async setShipping() {
            this.loading = true
            if(verifyField(this.verifyRules, this.form)) {
                try {
                    await this.api.activitySetShipping(Object.assign(this.form, {
                        access_token: localStorage.getItem("access_token"),
                        id: this.id,
                        type: 1
                    }))                

                    this.$message({ type: 'success', message: '已设为"已发货"状态' })
                    this.visible = false
                    this.$emit('statusChange', 1)
                }finally{
                    this.loading = false   
                }
            }else {
                this.loading = false
            }
        },
        closed() {
            this.$emit('input', false)
        }
    },
    watch: {
        value: {
            handler(val) {
                if(val) {
                    this.form = { expressCompany: '', expressOrderno: '' }
                    if(this.id === undefined || this.id === '') {
                        throw new Error('请传入兑换ID ')
                    }
                    this.activityWinningDetail()
                }
                this.visible = val
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss">
$prefixCls: 'w-update-shipment-status-dialog';

.#{$prefixCls} {
    &-user-info, &-logistics{
        padding: 0 40px;
        border-bottom: 1px solid #ddd;
        margin: 0 20px 20px;
    }
    &-logistics{
        border-bottom: 0;
    }
}
</style>